/**
 * Compact page-number list for the Uni Forms responses pager.
 *
 * Always includes first, last, and a radius around the current page.
 * Gaps become the string ``'…'`` so the UI can render an ellipsis
 * rather than every integer on a 200-page list.
 */
export function pageWindow(current, total, radius = 2) {
  const cur = Math.max(1, Number(current) || 1);
  const tot = Math.max(1, Number(total) || 1);
  if (tot <= 7) {
    return Array.from({ length: tot }, (_, i) => i + 1);
  }
  const pages = new Set([1, tot, cur]);
  for (let i = 1; i <= radius; i += 1) {
    pages.add(cur - i);
    pages.add(cur + i);
  }
  const sorted = [...pages].filter((p) => p >= 1 && p <= tot).sort((a, b) => a - b);
  const out = [];
  let prev = 0;
  sorted.forEach((p) => {
    if (prev && p > prev + 1) out.push('…');
    out.push(p);
    prev = p;
  });
  return out;
}
